export const log = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
   en: {
        log_management: 'Log Management',
        description: 'Description',
        date: 'Date',
        time: 'Time',
        url:'URL',
   },
   ar: {
     log_management: 'إدارة السجل',
     description: 'الوصف',
     date: 'التاريخ',
     time: 'الوقت',
     url:'URL',
},
}